import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as classNames from "classnames"
import './styles.scss'


class ScenarioEquilibrage extends React.Component {
    state={
        politicalApproch:[],
        pAObjectifi:[],
        pAreste:[],
        service:[],
        serviceObjectifi:[],
        serviceReste:[],
        currentTab:'',
        servicesRow:[],
        rowsPolitical:[],
        groupsTotal:[],
        showSaveButton:false,
        calculate:false
    }
    timer = null;

    componentDidMount(){
    /*calculating data on load of page through props*/
     let definition = this.props.tableDefinition.rows.filter(res=>res.hasOwnProperty("accountIds"))
     let arbitrage = this.props.scenario.arbitrage && this.props.scenario.arbitrage.arbitragePoliticalApproaches
     let table = this.props.tableDefinition.rows
     let currentTab = this.props.currentTab
     let retteValueSum = arbitrage.reduce((a, b) => ({x: a.recettesValue + b.recettesValue}));
     let despenseValueSum = arbitrage.reduce((a, b) => ({x: a.depensesValue + b.depensesValue}));
     let retteThemeValue = 0
     let despenseThemeValue = 0
     if(currentTab === "revenues"){
        let pAObjectifi=[],
        service=[],
        serviceObjectifi=[],
        serviceReste=[]
        arbitrage.map(res=>{
            let serviceData = res.servicePoliticalApproaches
            serviceObjectifi.push(serviceData.map(r=> { return {value:r.recettesValue,label:r.service.label,slug:r.service.slug} }))
            serviceReste.push(serviceData.map(r=>{ return {value:r.recettesValue,label:r.service.label,slug:r.service.slug} }))
            pAObjectifi.push({value:res.recettesValue,related:res.politicalApproach.services})
            service.push(res.servicePoliticalApproaches)
        })
        let mergingData =  this.props.data.map((res,I)=>{
            let data = []
            let tableData = table[I].hasOwnProperty("accountIds") ? {name:table[I].chapter ? `main ${table[I].chapter.label}` :'',...table[I]}: {name:table[I].chapter ? table[I].chapter.label :'',...table[I]}
                    serviceObjectifi.map(rr=>{
                      let newdata =[]
                      rr.map(ro=>{
                            let merge =[]
                                res.map(r=>{
                                    if(typeof r == 'object'&& r !== null ){
                                        if(typeof r == 'object'&& r !== null ){
                                            if(tableData.hasOwnProperty("accountIds") ){
                                                if(r.theme.label == ro.label){
                                                    merge.push({...r,...tableData,slug:ro.slug})
                                             }
                                            }else{
                                                if(r.theme.label == ro.label && r.account_id ==tableData.account.id ){
                                                    merge.push({...r,...tableData,slug:ro.slug})
                                             }
                                            }
                                        }
                                    }
                                })
                                if(merge.length >= 1){
                                    newdata.push(...merge)
                                }
                             })
                            if(newdata.length >= 1){
                        data.push(newdata)}})
                    return data }
        )
        let total = serviceObjectifi.map(r=>r.map(rr=>{return {name:'total',amount:'',label:rr.label,slug:rr.slug}}))
        mergingData.push(total)
        let final = mergingData.filter(res=> res.length > 0)

        this.setState({politicalApproch:arbitrage,pAObjectifi,service,serviceObjectifi,currentTab,pAreste:pAObjectifi,serviceReste,rowsPolitical:final,groupsTotal:final},()=>{
            let resteChange =[]
            let updatedData = this.state.rowsPolitical.map(res=>
                     res.map(rr=>{
                         let data =[]
                         let resteValue=[]
                     rr.map(ro=>{
                        let find = this.props.scenario.arbitrageScenarioAccountThemes.filter(r=>{
                             if(r.account_name == ro.title && r.theme_slug == ro.slug && r.account_id == ro.account_id && r.receipts == true){
                                    data.push({...ro,amount:r.amount})
                                 return {...ro,amount:r.amount}
                             }
                          })
                          if(find.length <=  0){
                             let total = 0
                             if(ro.name.includes("main") && ro.hasOwnProperty("accountIds")){
                                this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                    if(this.props.currentTab === "revenues"){
                                        if(r.receipts == true){
                                            if( r.theme_slug == ro.slug){
                                                if(ro.accountIds.includes(r.account_id)){
                                                   total = total + parseInt(r.amount)
                                                }
                                           }
                                        }
                                    }
                                })
                                data.push({...ro,amount:total == 0 ?'':total})
                            }else{
                             let total = 0
                             if(ro.name == "total" ){
                                 this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                     if(this.props.currentTab === "revenues"){
                                         if(r.receipts == true){
                                            if( r.theme_slug == ro.slug){
                                            total = total + parseInt(r.amount)
                                            }
                                         }
                                     }
                                 })
                                 data.push({...ro,amount:total == 0 ?'':total })
                                     this.state.serviceReste.map(roo=>{
                                         roo.map(g=>{
                                            if(g.slug == ro.slug){
                                                let value = g.value - total
                                                resteValue.push({...g,value})
                                            }
                                         })
                                     })
                             }else{
                                 data.push({...ro})
                             }
                            }
                          }
                         })
                         if(resteValue.length > 0){
                            resteChange.push(resteValue)
                         }
                         return data
                     }))
                     let pAServices=[]
                      this.state.pAreste.map((rs)=>{
                         let total = 0
                             resteChange.map(ro=>{
                                 ro.map(r=>{
                                     rs.related.map(rr=>{
                                     if(rr.slug == r.slug){
                                      total = total + r.value
                                     }
                                 })
                             })
                         })
                         pAServices.push({...rs,value:total})
                     })

                     this.setState({rowsPolitical:updatedData,serviceReste:resteChange,pAreste:pAServices})
        })

     }else{
        let pAObjectifi=[],
        service=[],
        serviceObjectifi=[],
        serviceReste=[]
        arbitrage.map(res=>{
            let serviceData = res.servicePoliticalApproaches
            serviceObjectifi.push(serviceData.map(r=> { return {value:r.depensesValue,label:r.service.label,slug:r.service.slug} } ))
            serviceReste.push(serviceData.map(r=> { return {value:r.depensesValue,label:r.service.label,slug:r.service.slug} } ))
            pAObjectifi.push({value:res.depensesValue,related:res.politicalApproach.services})
            service.push(res.servicePoliticalApproaches)
        })
        let mergingData = this.props.data.map((res,I)=>{
            let data = []
            let tableData = table[I].hasOwnProperty("accountIds") ? {name:table[I].chapter ? `main ${table[I].chapter.label}` :'',...table[I]}: {name:table[I].chapter ? table[I].chapter.label :'',...table[I]}
                    serviceObjectifi.map(rr=>{
                      let newdata =[]
                      rr.map(ro=>{
                        let merge =[]
                            res.map(r=>{
                                if(typeof r == 'object'&& r !== null ){
                                    if(typeof r == 'object'&& r !== null ){
                                        if(tableData.hasOwnProperty("accountIds") ){
                                            if(r.theme.label == ro.label){
                                                merge.push({...r,...tableData,slug:ro.slug})
                                         }
                                        }else{
                                            if(r.theme.label == ro.label && r.account_id ==tableData.account.id ){
                                                merge.push({...r,...tableData,slug:ro.slug})
                                         }
                                        }
                                    }
                                }
                            })
                            if(merge.length >= 1){
                                newdata.push(...merge)
                            }
                         })
                            if(newdata.length >= 1){
                                data.push(newdata)}
                    })
                    return data }
        )
let total = serviceObjectifi.map(r=>r.map(rr=>{return {name:'total',amount:'',label:rr.label,slug:rr.slug}}))
mergingData.push(total)
let final = mergingData.filter(res=> res.length > 0)
        this.setState({politicalApproch:arbitrage,pAObjectifi,service,serviceObjectifi,currentTab,pAreste:pAObjectifi,serviceReste,rowsPolitical:final,groupsTotal:final},()=>{
            let resteChange =[]
            let updatedData = this.state.rowsPolitical.map(res=>
                     res.map(rr=>{
                         let data =[]
                         let resteValue=[]
                     rr.map(ro=>{
                        let find = this.props.scenario.arbitrageScenarioAccountThemes.filter(r=>{
                             if(r.account_name == ro.title && r.theme_slug == ro.slug && r.account_id == ro.account_id && r.receipts == false){
                                    data.push({...ro,amount:r.amount})
                                 return {...ro,amount:r.amount}
                             }
                          })
                          if(find.length <=  0){
                             let total = 0
                             if(ro.name.includes("main") && ro.hasOwnProperty("accountIds")){
                                this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                    if(this.props.currentTab !== "revenues"){
                                        if(r.receipts == false){
                                            if( r.theme_slug == ro.slug){
                                                if(ro.accountIds.includes(r.account_id)){
                                                   total = total + parseInt(r.amount)
                                                }
                                           }
                                        }
                                    }
                                })
                                data.push({...ro,amount:total == 0 ?'':total})
                            }else{
                             let total = 0
                             if(ro.name == "total" ){
                                 this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                    if(this.props.currentTab !== "revenues"){
                                             if(r.receipts == false){
                                            if( r.theme_slug == ro.slug){
                                                total = total + parseInt(r.amount)
                                                }
                                            }
                                    }
                                 })
                                 data.push({...ro,amount:total == 0 ?'':total })
                                     this.state.serviceReste.map(roo=>{
                                         roo.map(g=>{
                                            if(g.slug == ro.slug){
                                                let value = g.value - total
                                                resteValue.push({...g,value})
                                            }
                                         })
                                     })
                             }else{
                                 data.push({...ro})
                             }
                            }
                          }
                         })
                         if(resteValue.length > 0){
                            resteChange.push(resteValue)
                         }
                         return data
                     }))
                     let pAServices=[]
                      this.state.pAreste.map((rs)=>{
                         let total = 0
                             resteChange.map(ro=>{
                                 ro.map(r=>{
                                     rs.related.map(rr=>{
                                     if(rr.slug == r.slug){
                                      total = total + r.value
                                     }
                                 })
                             })
                         })
                         pAServices.push({...rs,value:total})
                     })

                     this.setState({rowsPolitical:updatedData,serviceReste:resteChange,pAreste:pAServices})
        })
     }
     this.props.scenario.arbitrageScenarioAccountThemes.forEach(res=>{
          if(res.receipts == true){
            retteThemeValue = retteThemeValue + res.amount
          }
          if(res.receipts == false){
            despenseThemeValue = despenseThemeValue + res.amount
          }
          if(retteThemeValue == retteValueSum.x && despenseThemeValue == despenseValueSum.x){
            this.setState({showSaveButton:true})
        }
        if(retteThemeValue > retteValueSum.x || despenseThemeValue > despenseValueSum.x){
            this.setState({showSaveButton:false})
        }
     })
    }

    componentDidUpdate(prevProps){
        /*calculating data on reload the page or shift to another tab through props*/
        let definition = this.props.tableDefinition.rows.filter(res=>res.hasOwnProperty("accountIds"))
        let table = this.props.tableDefinition.rows
        let arbitrage = this.props.scenario.arbitrage && this.props.scenario.arbitrage.arbitragePoliticalApproaches
        let currentTab = this.props.currentTab
        let retteValueSum = arbitrage.reduce((a, b) => ({x: a.recettesValue + b.recettesValue}));
        let despenseValueSum = arbitrage.reduce((a, b) => ({x: a.depensesValue + b.depensesValue}));
        let retteThemeValue = 0
        let despenseThemeValue = 0
        if(this.state.currentTab !== this.props.currentTab || prevProps.tableDefinition.rows.length !== this.props.tableDefinition.rows.length ){
            if(this.state.currentTab !== this.props.currentTab ){
            this.setState({
                politicalApproch:[],
                pAObjectifi:[],
                pAreste:[],
                service:[],
                serviceObjectifi:[],
                serviceReste:[],
                currentTab:'',
                servicesRow:[],
                rowsPolitical:[],
                groupsTotal:[]})
            }
            if(currentTab === "revenues"){
                let pAObjectifi=[],
                service=[],
                serviceObjectifi=[],
                serviceReste=[]
                arbitrage.map(res=>{
                    let serviceData = res.servicePoliticalApproaches
                    serviceObjectifi.push(serviceData.map(r=>  { return {value:r.recettesValue,label:r.service.label,slug:r.service.slug} }))
                    serviceReste.push(serviceData.map(r=>  { return {value:r.recettesValue,label:r.service.label,slug:r.service.slug} }))
                    pAObjectifi.push({value:res.recettesValue,related:res.politicalApproach.services})
                    service.push(res.servicePoliticalApproaches)
                })
                let mergingData = this.props.data.map((res,I)=>{
                    let data = []
                    let tableData = table[I].hasOwnProperty("accountIds") ? {name:table[I].chapter ? `main ${table[I].chapter.label}` :'',...table[I]}: {name:table[I].chapter ? table[I].chapter.label :'',...table[I]}
                            serviceObjectifi.map(rr=>{
                              let newdata =[]
                              rr.map(ro=>{
                                let merge =[]
                                    res.map(r=>{
                                        if(typeof r == 'object'&& r !== null ){
                                            if(tableData.hasOwnProperty("accountIds") ){
                                                if(r.theme.label == ro.label){
                                                    merge.push({...r,...tableData,slug:ro.slug})
                                             }
                                            }else{
                                                if(r.theme.label == ro.label && r.account_id == tableData.account.id ){
                                                    merge.push({...r,...tableData,slug:ro.slug})
                                             }
                                            }
                                        }
                                    })
                                    if(merge.length >= 1){
                                        newdata.push(...merge)
                                    }
                                 })
                                    if(newdata.length >= 1){
                                        data.push(newdata)}
                            })
                            return data }
                )
        let total = serviceObjectifi.map(r=>r.map(rr=>{return {name:'total',amount:'',label:rr.label,slug:rr.slug}}))
        mergingData.push(total)
        let final = mergingData.filter(res=> res.length > 0)
                this.setState({politicalApproch:arbitrage,pAObjectifi,service,serviceObjectifi,currentTab,pAreste:pAObjectifi,serviceReste,rowsPolitical:final,groupsTotal:final},()=>{
                    let resteChange =[]
                    let updatedData = this.state.rowsPolitical.map(res=>
                             res.map(rr=>{
                                 let data =[]
                                 let resteValue=[]
                             rr.map(ro=>{
                                let find = this.props.scenario.arbitrageScenarioAccountThemes.filter(r=>{
                                     if(r.account_name == ro.title && r.theme_slug == ro.slug && r.account_id == ro.account_id && r.receipts == true){
                                            data.push({...ro,amount:r.amount})
                                         return {...ro,amount:r.amount}
                                     }
                                  })
                                  if(find.length <=  0){
                                     let total = 0
                                     if(ro.name.includes("main") && ro.hasOwnProperty("accountIds")){
                                        this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                            if(this.props.currentTab === "revenues"){
                                                if(r.receipts == true){
                                                    if( r.theme_slug == ro.slug){
                                                        if(ro.accountIds.includes(r.account_id)){
                                                           total = total + parseInt(r.amount)
                                                        }
                                                   }
                                                }
                                            }
                                        })
                                        data.push({...ro,amount:total == 0 ?'':total})
                                    }else{
                                     let total = 0
                                     if(ro.name == "total" ){
                                         this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                            if(this.props.currentTab === "revenues"){
                                                if(r.receipts == true){
                                                    if( r.theme_slug == ro.slug){
                                                        total = total + parseInt(r.amount)
                                                        }
                                                }
                                            }
                                         })
                                         data.push({...ro,amount:total == 0 ?'':total })
                                             this.state.serviceReste.map(roo=>{
                                                 roo.map(g=>{
                                                    if(g.slug == ro.slug){
                                                        let value = g.value - total
                                                        resteValue.push({...g,value})
                                                    }
                                                 })
                                             })
                                     }else{
                                         data.push({...ro})
                                     }
                                    }
                                  }
                                 })
                                 if(resteValue.length > 0){
                                    resteChange.push(resteValue)
                                 }
                                 return data
                             }))
                             let pAServices=[]
                              this.state.pAreste.map((rs)=>{
                                 let total = 0
                                     resteChange.map(ro=>{
                                         ro.map(r=>{
                                             rs.related.map(rr=>{
                                             if(rr.slug == r.slug){
                                              total = total + r.value
                                             }
                                         })
                                     })
                                 })
                                 pAServices.push({...rs,value:total})
                             })

                             this.setState({rowsPolitical:updatedData,serviceReste:resteChange,pAreste:pAServices})
                })
             }else{
                let pAObjectifi=[],
                service=[],
                serviceObjectifi=[],
                serviceReste=[]
                arbitrage.map(res=>{
                    let serviceData = res.servicePoliticalApproaches
                    serviceObjectifi.push(serviceData.map(r=>  { return {value:r.depensesValue,label:r.service.label,slug:r.service.slug} }))
                    serviceReste.push(serviceData.map(r=>  { return {value:r.depensesValue,label:r.service.label,slug:r.service.slug} } ))
                    pAObjectifi.push({value:res.depensesValue,related:res.politicalApproach.services})
                    service.push(res.servicePoliticalApproaches)
                })
                let mergingData = this.props.data.map((res,I)=>{
                    let data = []
                    let tableData = table[I].hasOwnProperty("accountIds") ? {name:table[I].chapter ? `main ${table[I].chapter.label}` :'',...table[I]}: {name:table[I].chapter ? table[I].chapter.label :'',...table[I]}
                            serviceObjectifi.map(rr=>{
                              let newdata =[]
                              rr.map(ro=>{
                                let merge =[]
                                    res.map(r=>{
                                        if(typeof r == 'object'&& r !== null ){
                                            if(typeof r == 'object'&& r !== null ){
                                                if(tableData.hasOwnProperty("accountIds") ){
                                                    if(r.theme.label == ro.label){
                                                        merge.push({...r,...tableData,slug:ro.slug})
                                                 }
                                                }else{
                                                    if(r.theme.label == ro.label && r.account_id ==tableData.account.id ){
                                                        merge.push({...r,...tableData,slug:ro.slug})
                                                 }
                                                }
                                            }
                                        }
                                    })
                                    if(merge.length >= 1){
                                        newdata.push(...merge)
                                    }
                                 })
                                    if(newdata.length >= 1){
                                        data.push(newdata)}
                            })
                            return data }
                )
        let total = serviceObjectifi.map(r=>r.map(rr=>{return {name:'total',amount:'',label:rr.label,slug:rr.slug}}))
        mergingData.push(total)
        let final = mergingData.filter(res=> res.length > 0)
                this.setState({politicalApproch:arbitrage,pAObjectifi,service,serviceObjectifi,currentTab,pAreste:pAObjectifi,serviceReste,rowsPolitical:final,groupsTotal:final},()=>{
                    let resteChange =[]
                    let updatedData = this.state.rowsPolitical.map(res=>
                             res.map(rr=>{
                                 let data =[]
                                 let resteValue=[]
                             rr.map(ro=>{
                                let find = this.props.scenario.arbitrageScenarioAccountThemes.filter(r=>{
                                     if(r.account_name == ro.title && r.theme_slug == ro.slug && r.account_id == ro.account_id && r.receipts == false){
                                            data.push({...ro,amount:r.amount})
                                         return {...ro,amount:r.amount}
                                     }
                                  })
                                  if(find.length <=  0){
                                     let total = 0
                                     if(ro.name.includes("main") && ro.hasOwnProperty("accountIds")){
                                        this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                            if(this.props.currentTab !== "revenues"){
                                                if(r.receipts == false){
                                                    if( r.theme_slug == ro.slug){
                                                        if(ro.accountIds.includes(r.account_id)){
                                                           total = total + parseInt(r.amount)
                                                        }
                                                   }
                                                }
                                            }
                                        })
                                        data.push({...ro,amount:total == 0 ?'':total})
                                    }else{
                                     let total = 0
                                     if(ro.name == "total" ){
                                         this.props.scenario.arbitrageScenarioAccountThemes.forEach(r=>{
                                            if(this.props.currentTab !== "revenues"){
                                                if(r.receipts == false){
                                                    if( r.theme_slug == ro.slug){
                                                        total = total + parseInt(r.amount)
                                                        }
                                                }
                                            }
                                         })
                                         data.push({...ro,amount:total == 0 ?'':total })
                                             this.state.serviceReste.map(roo=>{
                                                 roo.map(g=>{
                                                    if(g.slug == ro.slug){
                                                        let value = g.value - total
                                                        resteValue.push({...g,value})
                                                    }
                                                 })
                                             })
                                     }else{
                                         data.push({...ro})
                                     }
                                    }
                                  }
                                 })
                                 if(resteValue.length > 0){
                                    resteChange.push(resteValue)
                                 }
                                 return data
                             }))
                             let pAServices=[]
                              this.state.pAreste.map((rs)=>{
                                 let total = 0
                                     resteChange.map(ro=>{
                                         ro.map(r=>{
                                             rs.related.map(rr=>{
                                             if(rr.slug == r.slug){
                                              total = total + r.value
                                             }
                                         })
                                     })
                                 })
                                 pAServices.push({...rs,value:total})
                             })
                             this.setState({rowsPolitical:updatedData,serviceReste:resteChange,pAreste:pAServices})
                })
             }
        }

        if(this.state.calculate){
            this.props.scenario.arbitrageScenarioAccountThemes.forEach(res=>{
                if(res.receipts == true){
                  retteThemeValue = retteThemeValue + parseInt(res.amount)
                }
                if(res.receipts == false){
                  despenseThemeValue = despenseThemeValue + parseInt(res.amount)
                }
                if(retteThemeValue == retteValueSum.x && despenseThemeValue == despenseValueSum.x){
                  this.setState({showSaveButton:true})
              }else{
                this.setState({showSaveButton:false})
              }
              this.setState({calculate:false})
           })
        }
    }

    render() {
        let state = this.state
        let row = this.props.tableDefinition.rows

        return (
            <div className="scenario-admin">
			<div className="scenario-detail-header">
				<a
				className="back-to-list"
				href="javascript:void()"
				onClick={this.props.onBack}>
					<FontAwesomeIcon icon="backward"/>
				</a>
                <span className="scenario-title">
                EQUILIBRAGE DU SCÉNARIO DE FONCTIONNEMENT (VUE ADMIN COLLECTIVITE)
                </span>
				{/* {this.props.isSuperAdmin &&
				<a href="javascript:void(0);"
				onClick={this.props.onToggleAdmin}>
					<FontAwesomeIcon icon="asterisk"/>
				</a>} */}
			</div>

			<div className="tabs-container">
				<div className="tabs">
					<div
					className={classNames("tab", { active: this.props.currentTab === "revenues"})}
                    onClick={() => this.props.onTabChange("revenues")}>
						Recettes
					</div>

					<div
					className={classNames("tab", { active: this.props.currentTab === "spending"})}
                    onClick={() => this.props.onTabChange("spending")}>
						Dépenses
					</div>
                    {state.showSaveButton &&
                    <div className='buttonContainer' onClick={()=>this.props.CopyAllData(this.props.scenario)}>
                      <button className='button'>METTRE À JOUR LE SCÉNARIO DE FONCTIONNEMENT</button>
                    </div>}
				</div>
                  {/* <select>
                    <option>Non-defin</option>
                </select> */}
                <div className='main'>
                {!this.props.data.length &&
						<div className="no-accounts-scenario">Aucun chapitre disponible pour saisir la répartition</div>}
                <table id="customers">
                    <thead>
                        <tr>
                            {/* <th>Numéro</th> */}
                            <th className='fixRow' style={{width:'450px'}}>Article</th>
                            <th className='fixRowSecond'><p className='paraYear'><FontAwesomeIcon className='yearIcon' icon="building"/><br />{this.props.scenario.year}<br />
                            (Scenario)</p></th>
                            <th className='fixRowthree'><p className='paraYear'><FontAwesomeIcon className='yearIcon' icon="user"/><br />{this.props.scenario.year}<br />
                            (Gestionnaire)</p></th>
                            {this.state.politicalApproch.map((res,i)=>
                                <th  key={res.id} style={state.pAreste[i].value == 0 ? {backgroundColor:'green',padding:'none'}:{padding:'none'}}>{res.politicalApproach.name} (Objectif : {state.currentTab == "revenues" ? this.space(res.recettesValue) : this.space(res.depensesValue)}/Reste:{this.space(state.pAreste[i].value)})<br />

                                 <tr className='servicesHandling'>
                                {res.servicePoliticalApproaches.map((r,index)=>
                                    <th key={r.id} style={state.serviceReste[i][index].value == 0 ?{border: 'none',width:'100%',backgroundColor:'green'}:{border: 'none',width:'100%'}}>
                                        {state.serviceReste[i][index].value == 0 &&[<FontAwesomeIcon key={r.id} icon="check"
                                        // onClick={()=>this.props.onMouseDown(r.service)}
                                        />,<br/>]}
                                        {r.service.label}<br/> objectifi:{state.currentTab == "revenues" ? this.space(r.recettesValue) : this.space(r.depensesValue)}<br/>Reste : {state.serviceReste && state.serviceReste[i] && this.space(state.serviceReste[i][index].value)}
                                        </th>
                                )}
                                </tr>
                            </th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.data.map((res,i)=>
                        <tr key={i} >
                            {res[0].replace(/[^0-9]/g, '') || res[0] == 'Total'  ?
                            <td className={res[0] == "Total"? 'total fixRow': i % 2 == 0 ?'even fixRow':'odd fixRow'}><p className='paraChild' >{res[0]}</p></td>:
                            <td className={res[0] == "Total"? 'total fixRow': i % 2 == 0 ?'even fixRow':'odd fixRow'}><p className='mainPara'><span className="scenario-header-identifier">{row[i].chapter && row[i].chapter.number}</span>
                            <p className='para'>{res[0]}</p>{this.props.shownChapters.map(r=> { if(r.label == res[0] && r.tab == this.state.currentTab){return true}else{return false} }) ?
                            this.props.shownChapters.map(r=> { if(r.label == res[0] && r.tab == this.state.currentTab){return true}else{return false} }).includes(true) ? <button className='arrowbutton' onClick={()=>this.onToggleChapterRemove(res[0])}><FontAwesomeIcon icon="chevron-up"/></button>:
                            <button className='arrowbutton' onClick={()=>this.onToggleChapter(res[0])}><FontAwesomeIcon icon="chevron-down"/></button>:<button className='arrowbutton' onClick={()=>this.onToggleChapter(res[0])}><FontAwesomeIcon icon="chevron-down"/></button>}</p></td>
                            }
                            <td className={res[0] == "Total"? 'total fixRowSecond': i % 2 == 0 ?'even fixRowSecond':'odd fixRowSecond'}><p className='paraChildYear'>{res[1] ? `${this.space(Math.round(parseFloat(res[1])))} €` : ''} </p></td>
                            <td className={res[0] == "Total"? 'total fixRowthree': i % 2 == 0 ?'even fixRowthree':'odd fixRowthree'}><p className='paraChildYear'>{res[2] ? `${this.space(Math.round(parseFloat(res[2])))} €` : ''}</p></td>
                            {this.state.politicalApproch.map((rr,I)=>
                            <td key={I} className={res[0] == "Total"? 'total': i % 2 == 0 ?'even':'odd'}>
                                <tr className='servicesHandling'>
                                {rr.servicePoliticalApproaches.map((r,index)=>
                                res[0].replace(/[^0-9]/g, '')  ?
                                <td style={res[0] !== "Total"?{border: 'none',width:'100%',padding:'0px'}:{border: 'none',width:'100%',padding:'0px',color:'white'}} key={index}><input className="inputArea" value={state.rowsPolitical ?state.rowsPolitical[i] ? state.rowsPolitical[i][I] ? state.rowsPolitical[i][I][index] ? state.rowsPolitical[i][I][index].amount ? this.space(state.rowsPolitical[i][I][index].amount) :'':'':'':'':''}  onChange={(e)=>this.handleChange(e,res[0].replace(/[^0-9]/g, ''),i,I,index)}/></td> :
                                <td style={res[0] !== "Total"?{border: 'none',width:'100%',padding:'0px'}:{border: 'none',width:'100%',padding:'0px',color:'white'}} key={index}><input className={res[0] == "Total"? 'total':i % 2 == 0 ?'evenInput' :'oddInput'} value={state.rowsPolitical ?state.rowsPolitical[i] ? state.rowsPolitical[i][I] ? state.rowsPolitical[i][I][index] ? state.rowsPolitical[i][I][index].amount ? this.space(state.rowsPolitical[i][I][index].amount) :'' :'':'':'':''} disabled='true'/>
                                </td>
                                )}
                                </tr>
                            </td>
                            )}
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
        )
    }

    onToggleChapter(name){
        this.props.tableDefinition.rows.map(res=>{
        if(res.chapter && res.chapter.label == name){
            this.props.onToggleChapter(res.chapter)
        }
        })
    }

    onToggleChapterRemove(name){
        this.props.tableDefinition.rows.map(res=>{
            if(res.chapter && res.chapter.label == name){
                this.props.onToggleChapterRemove(res.chapter)
            }
            })
    }

    space(x) {
        if(x){
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
        if(x == 0){
            return 0
        }
    }


   /*calculating data on user input*/
    handleChange(e,code,i,I,index){
        let value = e.target.value.replace(/ /g,'')
        let data = this.state.rowsPolitical
        let reste =  this.state.serviceReste
        let objectifi =  this.state.serviceObjectifi
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.props.onChange(data[i][I][index])
            this.setState({calculate:true})
        }, 1000);
        data[i][I][index].amount=value
        let name = data[i][I][index].name
        this.setState({rowsPolitical:data},()=>{
            let totalGroupValue = 0
            let total=0
            let totalValue = this.state.rowsPolitical
            let resteValue = 0
            let groupsTotal=this.state.rowsPolitical

            this.state.rowsPolitical.map(res=>{
                    if(res[I][index].name == name){
                      totalGroupValue = totalGroupValue + parseInt(res[I][index].amount ?res[I][index].amount:0)
                    }
            })
            this.state.groupsTotal.map((rr,i)=>{
                if(rr[I][index].name == `main ${name}`){
                    groupsTotal[i][I][index].amount= totalGroupValue
                }
            })
            this.state.rowsPolitical.map((res,i)=>{
                if(res[I][index].name.indexOf('main') != -1){
                    total = total + parseInt(res[I][index].amount ?res[I][index].amount:0)
                }
                if(res[I][index].name == 'total'){
                    totalValue[i][I][index].amount = total
                }
              })

                resteValue = parseInt(objectifi[I][index].value ? objectifi[I][index].value: 0) - parseInt(total)
                reste[I][index].value=  resteValue
            this.setState({groupsTotal,rowsPolitical:totalValue,serviceReste:reste},()=>{
                    // let ResteTotal = 0
                    // let pAreste = this.state.pAreste
                    // this.state.serviceReste[I].map(res=>{
                    //     ResteTotal = parseInt(ResteTotal) + parseInt(res.value)
                    // })

                    // pAreste[I].value =  ResteTotal
                    // this.setState({pAreste})
                })
            })
    }
}

export default ScenarioEquilibrage



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/scenario_equilibrage.js